import { render, staticRenderFns } from "./AutoNumbering.vue?vue&type=template&id=65082d2e"
import script from "./AutoNumbering.vue?vue&type=script&lang=js"
export * from "./AutoNumbering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports